import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './AdminLayout.module.scss';
import AdminNavbar from '@src/components/AdminNavbar';
const AdminLayout = ({ children }) => {
    return (_jsxs("div", { className: styles.adminLayout, children: [_jsx(AdminNavbar, {}), _jsx("main", { className: styles.adminMain, children: children })] }));
};
export default AdminLayout;
